  const calculateTaskEfficiency = (time, intensity = 20) => {
    if (time <= 1) return 0;

    const maxTime = 30; // Maximum task time in minutes
    const minTime = 2; // Minimum task time in minutes

    // Constrain time within min and max bounds
    const boundedTime = Math.max(minTime, Math.min(time, maxTime));

    // Calculate score inversely proportional to task time, adjusted by intensity
    const calculatedScore =
      ((maxTime - boundedTime) / (maxTime - minTime)) * intensity;
    return Math.round(calculatedScore * 100) / 100; // Rounded to 2 decimal places
  };

  const calculateTaskTimeEfficiency = (task) => {
    const { estimatedTaskTime, remainingTime } = task;
    const completionTime = estimatedTaskTime - remainingTime;
    let scoreBonus = 0;

    // Bonus or penalty based on completion time conditions
    const highCompletionThreshold = 0.25 * estimatedTaskTime; // Adjust to make the bonus threshold more specific
    if (remainingTime > 0 && completionTime >= highCompletionThreshold) {
      scoreBonus += 1; // Increased bonus if task is completed significantly under estimated time
    } else if (completionTime < 0) {
      scoreBonus -= 2; // Increased penalty if task time exceeded
    }

    return scoreBonus;
  };

  export const giveMeTaskScore = (task) => {
    const intensityVar = 2; // Adjusted intensity to match the scoring structure
    const baseScore = calculateTaskEfficiency(
      task.estimatedTaskTime / 60,
      intensityVar
    );

    // Apply the score bonus/penalty only if it's not a "break" task
    if (task.taskName.toLowerCase() !== "break") {
      return baseScore + calculateTaskTimeEfficiency(task);
    }

    // For "break" tasks, return only the efficiency score
    return calculateTaskTimeEfficiency(task);
  };

